import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from 'app/design/primitives/text';
import { useUser } from 'app/network/user';
import { FeatureFlag, isFeatureEnabled } from 'app/utils/helpers';
import { LoanFeeDocumentPreview } from './loan-fee-document-preview';

export function LoanFeePaymentDetails({
  document,
  paymentMethod,
  showPaymentMethod = true,
}: {
  document?: string | null;
  paymentMethod?: string | null;
  showPaymentMethod?: boolean;
}) {
  const { t } = useTranslation('loanFee');
  const { data: user } = useUser();
  if (isFeatureEnabled(FeatureFlag.loanFeeDocument, user?.featureFlags)) {
    return document ? <LoanFeeDocumentPreview url={document} /> : null;
  }
  return showPaymentMethod ? (
    <Text variant="bodyBase">
      {t('fields.loanFeePaymentMethodLabel')} :{' '}
      {paymentMethod ? t(`paymentMethods.${paymentMethod}`) : t('N/A', { ns: 'common' })}
    </Text>
  ) : null;
}
